import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export interface ContactData {
  _id: string;
  fullName: string;
  email: string;
  address: string;
  subject: string;
  message: string;
  createdAt: string;
  updatedAt: string;
}

export interface ContactsResponse {
  success: boolean;
  message: string;
  data: ContactData[];
}

export const contactsApi = createApi({
  reducerPath: "contactsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    // prepareHeaders: (headers) => {
    //   const token = localStorage.getItem("accessToken");
    //   if (token) {
    //     headers.set("Authorization", `Bearer ${token}`);
    //   }
    //   return headers;
    // },
    credentials: "include", // Ensure cookies are sent
  }),
  tagTypes: ["Contacts"],
  endpoints: (builder) => ({
    getContacts: builder.query<ContactsResponse, void>({
      query: () => "/contact",
      providesTags: ["Contacts"],
    }),
    deleteContact: builder.mutation<any, string>({
      query: (id) => ({
        url: `/contact/delete-contact/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Contacts"],
    }),
  }),
});

export const { useGetContactsQuery, useDeleteContactMutation } = contactsApi;
